/* eslint-disable no-unused-vars */
import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
import router from '@/router';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import { configuration } from './aws-exports';
import { log } from '@/constants.js';

Amplify.configure(configuration);

// -------------------- AUTH --------------------------
// You can get the current config object
export const currentConfig = Auth.configure();

export const getJwtToken = async () => {
  const session = await Auth.currentSession();
  const jwt = session.getAccessToken().getJwtToken();

  return jwt;
};

export const getJwtIDToken = async () => {
  const session = await Auth.currentSession();
  const jwt = session.getIdToken().getJwtToken();

  return jwt;
};

export const logOff = async () => {
  try {
    await Auth.signOut();
  } catch (error) {
    log.error(error);
  }
};

// -------------------- GRAPHQL --------------------

// ---------- APP USER
export const updateAppUser = async (
  app_user_id,
  name,
  surname,
  email,
  phone,
  language,
  user_map_style
) =>
  await API.graphql(
    graphqlOperation(mutations.updateAppUser, {
      app_user_id,
      name,
      surname,
      email,
      phone,
      language,
      user_map_style
    })
  );

export const getAppUser = async (app_user_id) =>
  await API.graphql(
    graphqlOperation(queries.getAppUser, {
      app_user_id
    })
  );

export const getAppUserPolicy = async input =>
  await API.graphql(
    graphqlOperation(queries.listAppUserPolicy, {
      input
    })
  );

export const getEnabledServicesPolicy = async input =>
  await API.graphql(
    graphqlOperation(queries.listEnabledServicesPolicy, {
      input
    })
  );

export const getGlobalLayer = async crm_id =>
  await API.graphql(graphqlOperation(queries.getGlobalLayer, {
    crm_id
  }));

export const getCustomerGlobalLayer = async crm_id =>
  await API.graphql(graphqlOperation(queries.getCustomerGlobalLayer, {
    crm_id
  }));

// --------------- TRANSLATIONS

export const listTranslations = async lang =>
  await API.graphql(graphqlOperation(queries.listTranslations, { lang }));

// ---------- TICKETING SERVICE
export const getTicketingServiceConfiguration = async service_id =>
  await API.graphql(
    graphqlOperation(queries.getTicketingServiceConfiguration, {
      service_id
    })
  );

export const createTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(mutations.createTicketingRequest, { input })
  );

export const linkLocationToTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(mutations.linkLocationToTicketingRequest, { input })
  );

export const listEvasionLimitSlots = async dates_to_check =>
  await API.graphql(
    graphqlOperation(queries.listEvasionLimitSlots, { dates_to_check })
  );

export const listTicketingNonOperationalWindows = async fromDate =>
  await API.graphql(
    graphqlOperation(queries.listTicketingNonOperationalWindows, {
      fromDate,
      mergeOverlapping: true
    })
  );

export const listComuniProvince = async is_prov =>
  await API.graphql(
    graphqlOperation(queries.listComuniProvince, { is_prov })
  );

export const listDocumentMeteoTypes = async type =>
  await API.graphql(
    graphqlOperation(queries.listDocumentMeteoTypes, { type })
  );

export const getTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(queries.getTicketingRequest, { input })
  );

export const deleteTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(mutations.deleteTicketingRequest, { input })
  );

export const linkDocumentS3ToTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(mutations.linkDocumentS3ToTicketingRequest, { input })
  );

export const getLinkedDocumentS3toTicketingRequest = async request_id =>
  await API.graphql(
    graphqlOperation(queries.getLinkedDocumentS3toTicketingRequest, {
      request_id
    })
  );

export const deleteDocumentS3 = async document_s3_id =>
  await API.graphql(
    graphqlOperation(mutations.deleteDocumentS3, {
      document_s3_id
    })
  );

export const editTicketingRequest = async input =>
  await API.graphql(
    graphqlOperation(mutations.editTicketingRequest, { input })
  );

export const listTicketingRequestLimit = async crm_id =>
  await API.graphql(
    graphqlOperation(queries.listTicketingRequestLimit, { crm_id })
  );

// ---------- GLOBAL LAYERS
export const createGlobalLayer = async input =>
  await API.graphql(graphqlOperation(mutations.createGlobalLayer, { input }));

export const editGlobalLayer = async input =>
  await API.graphql(graphqlOperation(mutations.editGlobalLayer, { input }));

export const getCustomerLayer = async crm_id =>
  await API.graphql(graphqlOperation(queries.getCustomerLayer, { crm_id }));

export const deleteCustomerLayer = async input =>
  await API.graphql(graphqlOperation(mutations.deleteCustomerLayer, { input }));

// ---------- MANUALS
export const listServiceManuals = async app_user_id =>
  await API.graphql(graphqlOperation(queries.listServiceManuals, { app_user_id }));

export const listCustomerManuals = async customer_id =>
  await API.graphql(graphqlOperation(queries.listCustomerManuals, { customer_id }));

// ---------- DEFAULT SERVICE
export const getDefaultService = async input =>
  await API.graphql(graphqlOperation(queries.getDefaultService, { input }));

// ---------- REPORT-HUB
export const listFolderObjects = async input =>
  await API.graphql(
    graphqlOperation(queries.listFolderObjects, { input })
  );

// ---------- VIDEO TUTORIAL
export const listVideoTutorial = async input =>
  await API.graphql(
    graphqlOperation(queries.listVideoTutorial, { input })
  );
